namespace TotalPoll {
    import Component = TotalCore.Common.Component;
    import ILocationService = angular.ILocationService;
    import Processable = TotalCore.Common.Processable;
    import RepositoryService = TotalPoll.RepositoryService;

    @Component('components.totalpoll', {
        templateUrl: 'entries-browser-component-template',
        bindings: {}
    })
    class EntriesBrowserComponent extends Processable {
        public columns = {
            'status': true,
            'action': true,
            'date': true,
            'ip': true,
            'browser': true,
        };
        public currentPage = 1;
        public entries = [];
        public fields = {};
        public filters: any = {};
        public labels = {
            'user': 'User',
            'sentVia': 'Sent via',
            'env': 'Environment',
        };
        public lastPage = true;
        public polls: any = {};
        public processing = true;

        constructor(private RepositoryService: RepositoryService, private $location: ILocationService) {
            super();
            let urlParams = $location.search();

            this.currentPage = Math.abs(Number(urlParams['currentPage']) || 1);
            this.filters.poll = Number(urlParams['poll']) || null;
            this.filters.from = urlParams['from'] || null;
            this.filters.to = urlParams['to'] || null;
        }

        $onInit() {
            this.loadPolls();
            if (this.filters.poll) {
                this.loadPage(this.currentPage);
            }
        }

        canExport() {
            return this.entries.length > 0;
        }

        exportAs(format) {
            this.RepositoryService.getDownload(format, this.filters);
        }

        getFields() {
            if (this.filters.poll) {
                for (let poll of this.polls) {
                    if (poll.id == this.filters.poll) {
                        return poll.fields;
                    }
                }
            }

            return [];
        }

        hasNextPage() {
            return !this.lastPage;
        }

        hasPreviousPage() {
            return this.currentPage != 1;
        }

        isFirstPage() {
            return this.currentPage === 1;
        }

        isLastPage() {
            return this.lastPage;
        }

        isPage(page) {
            return this.currentPage == page;
        }

        isProcessing() {
            return this.processing;
        }

        loadPage(page: number) {
            if (!this.filters.poll) {
                this.updateUrl();
                this.entries = [];
                return false;
            }

            this.processing = true;
            this.RepositoryService
                .getPage(page, this.filters)
                .then((response) => {
                    this.processing = false;
                    this.currentPage = page;
                    this.entries = response['entries'];
                    this.lastPage = response['lastPage'];
                    this.updateUrl();
                })
                .catch((response) => {
                    if (confirm(`Something went wrong in the last operation (${response.status} ${response.statusText || 'Unknown error'}). Retry?`)) {
                        this.loadPage(page);
                    }
                });
        }

        loadPolls() {
            this.processing = true;
            this.RepositoryService
                .getPolls()
                .then((response) => {
                    this.processing = false;
                    this.polls = response;
                })
                .catch((response) => {
                    if (confirm(`Something went wrong in the last operation (${response.status} ${response.statusText || 'Unknown error'}). Retry?`)) {
                        this.loadPolls();
                    }
                });
        }

        nextPage() {
            this.loadPage(this.currentPage + 1);
        }

        previousPage() {
            this.loadPage(this.currentPage - 1);
        }

        resetFilters() {
            this.filters.from = null;
            this.filters.to = null;
            this.loadPage(1);
        }

        updateUrl() {
            this.$location.search(angular.extend({}, this.$location.search(), this.filters, {currentPage: this.currentPage}));
        }
    }
}